import React from 'react'

import { StyledTimestampUpdated } from '../Byline.styled'
import { TimestampFormat } from '../../../typography/Timestamp/Timestamp'

interface BylineTimestampUpdatedProps {
    timestamp: string | undefined
    timestampUpdatedFormat: TimestampFormat
}

export const BylineTimestampUpdated: React.FC<BylineTimestampUpdatedProps> = ({
    timestamp,
    timestampUpdatedFormat,
}) => {
    if (!timestamp) {
        return null
    }

    return (
        <StyledTimestampUpdated
            timestamp={timestamp}
            timestampLabel={'Updated:'}
            timestampFormat={timestampUpdatedFormat}
        />
    )
}
